import { SupportingDocuments } from './plan.interface'

// Note: this same enum currently exists in BFF, intentionally duplicated in FE
export enum ImageTypeEnum {
  ELEVATION = 'elevation',
  FLOORPLAN_DEFAULT = 'floorplan_default',
  FLOORPLAN_OPTION = 'floorplan_option',
  FLOORPLAN_REVERSED = 'floorplan_reversed',
  OTHER = 'other',
}

// Note: this same interface currently exists in BFF, intentionally duplicated in FE
// Note: this interface is for community images
export interface PlanImage {
  alt: string
  communityNumber: string
  description: string
  floorplanName?: string
  planNumber: string
  title: string
  type: ImageTypeEnum
  url: string
}

export enum CorePlanImageTabType {
  ARCHITECTURE_AND_ENGINEERING = 'architectureAndEngineering',
  FLOOR_PLANS = 'floorPlans',
  RENDERINGS = 'renderings',
}

// Note: alt, description and title are the core image's file name
// for now until core image meta data is available
export interface CorePlanImage {
  alt: string // this is the core image file name
  description: string // this is the core image file name
  elevation?: string
  fileTab: string
  floorNumber: string
  floorplanName?: string
  mimeType: string
  planNumber: string
  title: string // this is the core image file name
  type: ImageTypeEnum
  url: string
}

// Note: these values are the same values that coming through the community images api response.
// this enum is to only be used for community plans
export enum ImageFloorPlanTypeEnum {
  BASEMENT = 'Basement',
  EIGHTH_FLOOR = '8th Floor',
  FIFTH_FLOOR = '5th Floor',
  FIRST_FLOOR = '1st Floor',
  FOURTH_FLOOR = '4th Floor',
  NINTH_FLOOR = '9th Floor',
  SECOND_FLOOR = '2nd Floor',
  SEVENTH_FLOOR = '7th Floor',
  SIXTH_FLOOR = '6th Floor',
  THIRD_FLOOR = '3rd Floor',
}

export const MapFloorPlanToFileName: {
  [label: ImageFloorPlanTypeEnum]: string
} = {
  [ImageFloorPlanTypeEnum.BASEMENT]: 'Basement',
  [ImageFloorPlanTypeEnum.EIGHTH_FLOOR]: 'Floor_Plan_8',
  [ImageFloorPlanTypeEnum.FIFTH_FLOOR]: 'Floor_Plan_5',
  [ImageFloorPlanTypeEnum.FIRST_FLOOR]: 'Floor_Plan_1',
  [ImageFloorPlanTypeEnum.FOURTH_FLOOR]: 'Floor_Plan_4',
  [ImageFloorPlanTypeEnum.NINTH_FLOOR]: 'Floor_Plan_9',
  [ImageFloorPlanTypeEnum.SECOND_FLOOR]: 'Floor_Plan_2',
  [ImageFloorPlanTypeEnum.SEVENTH_FLOOR]: 'Floor_Plan_7',
  [ImageFloorPlanTypeEnum.SIXTH_FLOOR]: 'Floor_Plan_6',
  [ImageFloorPlanTypeEnum.THIRD_FLOOR]: 'Floor_Plan_3',
}

// Note: 0 for basement is an assumption at the moment. When user uploads floor plans
// in upload floor plans tab, a rule should be decided for basement option
export const MapFloorNumberToFileName: {
  [label: string]: string
} = {
  '0': 'Basement',
  '1': 'Floor_Plan_1',
  '2': 'Floor_Plan_2',
  '3': 'Floor_Plan_3',
  '4': 'Floor_Plan_4',
  '5': 'Floor_Plan_5',
  '6': 'Floor_Plan_6',
  '7': 'Floor_Plan_7',
  '8': 'Floor_Plan_8',
  '9': 'Floor_Plan_9',
}

export interface CoreImageResponse extends SupportingDocuments {
  // Legacy base64 payload, no longer sent by the BFF; kept optional during rollout.
  coreImageFile?: string
  // Same-origin, CDN-cacheable URL to the image bytes (replaces coreImageFile).
  coreImageUrl: string
  elevation: string
  floorNumber?: number
  imageReversed?: boolean
}
